// extracted by mini-css-extract-plugin
module.exports = {"coverLink":"U","contentBox":"V","zapposPromoContainer":"W","zapposPromoGroupContainer":"X","promos":"Y","bottom":"Z","top":"_","right":"aa","left":"ba"};